(function () {
  if (window.__dtc3HowItWorksLoaded) return;
  window.__dtc3HowItWorksLoaded = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileQuery = window.matchMedia('(max-width: 900px)');

  function setFallbackState(container, shouldShow) {
    const playButton = container.querySelector('[data-dtc3-how-inline-play]');
    container.toggleAttribute('data-dtc3-video-autoplay-failed', shouldShow);
    if (playButton) {
      playButton.hidden = !shouldShow;
    }
  }

  function syncVideo(container, shouldPlay) {
    const video = container.matches('[data-dtc3-how-card]')
      ? container.querySelector('.dtc3-how-card__expanded video')
      : container.querySelector('video');
    if (!video) return;

    container.querySelectorAll('video').forEach((item) => {
      if (item === video) return;
      item.pause();
      item.currentTime = 0;
    });

    if (!shouldPlay) {
      video.pause();
      video.currentTime = 0;
      setFallbackState(container, false);
      return;
    }

    if (prefersReducedMotion) {
      video.pause();
      setFallbackState(container, true);
      return;
    }

    setFallbackState(container, false);
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        setFallbackState(container, true);
      });
    }
  }

  function initHowCards(root) {
    if (root.dataset.dtc3HowInitialized === 'true') return;

    const cards = root.querySelectorAll('[data-dtc3-how-card]');
    if (!cards.length) return;

    root.dataset.dtc3HowInitialized = 'true';

    function setActive(card) {
      cards.forEach((item) => {
        const isActive = item === card;
        item.classList.toggle('is-active', isActive);
        syncVideo(item, isActive && !mobileQuery.matches);
      });
    }

    function updateDesktopPlayback() {
      cards.forEach((item) => {
        syncVideo(item, item.classList.contains('is-active') && !mobileQuery.matches);
      });
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateDesktopPlayback);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateDesktopPlayback);
    }

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => setActive(card));
      card.addEventListener('click', () => setActive(card));
      card.addEventListener('focus', () => setActive(card));
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setActive(card);
      });
    });

    setActive(root.querySelector('[data-dtc3-how-card].is-active') || cards[0]);
  }

  function initHowMobileTabs(root) {
    root.querySelectorAll('[data-dtc3-how-mobile-tabs]').forEach((tabsRoot) => {
      if (tabsRoot.dataset.dtc3HowMobileInitialized === 'true') return;

      const tabs = Array.from(tabsRoot.querySelectorAll('[data-dtc3-how-mobile-tab]'));
      const tabList = tabsRoot.querySelector('.dtc3-how-mobile-tabs__tablist');
      const mediaPanels = Array.from(tabsRoot.querySelectorAll('[data-dtc3-how-mobile-media]'));
      const contentPanels = Array.from(tabsRoot.querySelectorAll('[data-dtc3-how-mobile-panel]'));
      if (!tabs.length) return;

      tabsRoot.dataset.dtc3HowMobileInitialized = 'true';

      function getCurrentIndex() {
        const activeIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        return activeIndex >= 0 ? activeIndex : 0;
      }

      function syncPanels(panels, activeIndex) {
        panels.forEach((panel, index) => {
          const isActive = index === activeIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
          syncVideo(panel, isActive && mobileQuery.matches);
        });
      }

      function setActive(index, options = {}) {
        const shouldFocus = Boolean(options.shouldFocus);
        const shouldScroll = Boolean(options.shouldScroll);
        const activeIndex = Math.max(0, Math.min(index, tabs.length - 1));

        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === activeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        syncPanels(mediaPanels, activeIndex);
        syncPanels(contentPanels, activeIndex);

        if (shouldFocus) {
          tabs[activeIndex].focus({ preventScroll: true });
        }

        if (shouldScroll && tabList) {
          const activeTab = tabs[activeIndex];
          const targetScrollLeft =
            activeTab.offsetLeft - (tabList.clientWidth - activeTab.offsetWidth) / 2;

          tabList.scrollTo({
            left: targetScrollLeft,
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
          });
        }
      }

      function updateMobilePlayback() {
        syncPanels(mediaPanels, getCurrentIndex());
      }

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', updateMobilePlayback);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(updateMobilePlayback);
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => setActive(index, { shouldScroll: true }));
        tab.addEventListener('keydown', (event) => {
          const currentIndex = getCurrentIndex();
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          setActive(nextIndex, { shouldFocus: true, shouldScroll: true });
        });
      });

      mediaPanels.forEach((panel) => {
        const playButton = panel.querySelector('[data-dtc3-how-inline-play]');
        if (!playButton) return;

        playButton.addEventListener('click', () => {
          const video = panel.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.playsInline = true;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => setFallbackState(panel, false))
              .catch(() => setFallbackState(panel, true));
          }
        });
      });

      setActive(getCurrentIndex(), { shouldScroll: false });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-dtc3-how]').forEach((root) => {
      initHowCards(root);
      initHowMobileTabs(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
